<script lang="ts">
  import type { Snippet } from "svelte";
  import { page } from "$app/state";

  let {
    report,
    playerId,
    gameId,
    pageUrl,
    children
  }: {
    report?: string;
    playerId?: string;
    gameId?: string;
    pageUrl?: string;
    children?: Snippet;
  } = $props();

  // https://docs.google.com/forms/d/e/1FAIpQLScy93LYm-oKnUYiqkSYwkoFzkYdhdiofHIDz0SBXKFDeiUdCA/viewform?usp=pp_url&entry.2139814786=player_id&entry.2013493120=game_id&entry.2024553282=url&entry.1926249505=report
  const FORM_BASE =
    "https://docs.google.com/forms/d/e/1FAIpQLScy93LYm-oKnUYiqkSYwkoFzkYdhdiofHIDz0SBXKFDeiUdCA/viewform";

  let bugReportUrl = $derived.by(() => {
    const params = new URLSearchParams({
      usp: "pp_url",
      "entry.2139814786": playerId ?? page.data.profile?.id ?? "",
      "entry.2013493120": gameId ?? page.params.id ?? "",
      "entry.2024553282": pageUrl ?? page.url.pathname,
      "entry.1926249505": report ?? ""
    });
    return `${FORM_BASE}?${params.toString()}`;
  });
</script>

<a href={bugReportUrl} target="_blank" rel="noopener noreferrer external" class="font-bold">
  {#if children}{@render children()}{:else}Report a Bug{/if}
</a>
